export interface ICommissionData {
    readonly commissionNumber: string;
    readonly bid: string;
    readonly commissionNumberYear: string;
}

export class CommissionIdConverter {
    public static convertCommissionDataToId(commissionNumber?: string, bid?: string, commissionNumberYear?: string): string | undefined {
        if (!commissionNumber || !commissionNumberYear || !bid) {
            return undefined;
        }
        return `${commissionNumber}-${bid}-${commissionNumberYear}`;
    }

    public static convertCommissionIdToData(commissionId?: string): ICommissionData | undefined {
        const splits = commissionId?.split('-');
        if (!splits || splits.length !== 3 || !(splits[0] && splits[1] && splits[2])) {
            return undefined;
        }
        return {
            commissionNumber: splits[0],
            bid: splits[1],
            commissionNumberYear: splits[2]
        };
    }
}
